module.exports = __webpack_public_path__ + "img/Bear02.8c0c44bf.png";